import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

const UploadIcon = (props: IconProps) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='auto'
    {...props}
  >
    <path
      stroke='none'
      d='M0 0h24v24H0z'
      fill='none'
    />
    <path d='M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2' />
    <path d='M7 9l5 -5l5 5' />
    <path d='M12 4l0 12' />
  </Icon>
);

export default UploadIcon;
